import request from '@/utils/request'

//=====================线下商品===========start=================//
// 线下商品list
export function productQuery(data) {
  return request({
    url: '/product/list',
    method: 'post',
    data
  })
}
// 线下商品新增
export function productAdd(data) {
  return request({
    url: '/product/add',
    method: 'post',
    data
  })
}
// 线下商品详情
export function productDetail(data) {
  return request({
    url: '/product/detail',
    method: 'post',
    data
  })
}
// 线下商品修改
export function productUpdate(data) {
  return request({
    url: '/product/update',
    method: 'post',
    data
  })
}
// 线下禁用
export function productForbid(data) {
  return request({
    url: '/product/disable',
    method: 'post',
    data
  })
}
// 线下启用
export function productResume(data) {
  return request({
    url: '/product/enable',
    method: 'post',
    data
  })
}

// 维护电子秤=》线下商品删除
export function productDelete(data) {
  return request({
    url: '/product/delete',
    method: 'post',
    data
  })
}

// 维护电子秤=》 提交
export function productSubmit(data) {
  return request({
    url: '/product/sale/update',
    method: 'post',
    data
  })
}

//=====================线上商品===========start=================//
// 线上商品list
export function getOnlineProductList(data) {
  return request({
    url: '/product/online/sku/list',
    method: 'post',
    data
  })
}

// 新线上商品list-兼容地区限制
export function getOnlineAreaProductList(data) {
  return request({
    url: '/product/online/areaSku/list',
    method: 'post',
    data
  })
}
// 线上商品 导出
export function exportOnlineProduct(data) {
  return request({
    url: '/product/online/sku/list/export',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}
// 精简版的线上商品导出
export function exportTidyOnlineProduct(data) {
  return request({
    url: '/product/online/sku/tidyList/export',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}
// 线上商品详情
export function getOnlineProductDetail(data) {
  return request({
    url: '/product/online/sku/detail',
    method: 'post',
    data
  })
}

// 获取自定义规格名
export function getSpecValues(data) {
  return request({
    url: '/product/online/spec/create',
    method: 'post',
    data
  })
}

// 线上商品新增
export function addOnlineProduct(data) {
  return request({
    url: '/product/online/add',
    method: 'post',
    data
  })
}
// 线上商品新增草稿
export function addOnlineProductDraft(data) {
  return request({
    url: '/product/draft/add',
    method: 'post',
    data
  })
}
// 线上商品新增草稿
export function onlineProductDraftList(data) {
  return request({
    url: '/product/draft/list',
    method: 'post',
    data
  })
}
// 线上商品草稿详情
export function onlineProductDraftDetail(data) {
  return request({
    url: '/product/draft/detail',
    method: 'post',
    data
  })
}
// 线上商品草稿删除
export function onlineProductDraftDelete(data) {
  return request({
    url: '/product/draft/delete',
    method: 'post',
    data
  })
}
// 线上商品修改
export function editOnlineProduct(data) {
  return request({
    url: '/product/online/sku/update',
    method: 'post',
    data
  })
}

// 卖家端仓库sku列表
export function getSkuProductList(data) {
  return request({
    url: '/product/stock/sku/list',
    method: 'post',
    data
  })
}

// 商品口感
export function getSkuTextureList(data) {
  return request({
    url: '/product/texture/list',
    method: 'post',
    data
  })
}

// 商品产地
export function getAreaList(data) {
  return request({
    url: '/product/area/list',
    method: 'post',
    data
  })
}

// 商品品级
export function getGradeList(data) {
  return request({
    url: '/product/grade/list',
    method: 'post',
    data
  })
}

// 查找商户违约金
export function findShopDefaultRate(data) {
  return request({
    url: '/shop/findDefaultRate',
    method: 'post',
    data
  })
}

//阶梯价调整商户分摊比记录
export function getShopClearRationLog(data) {
  return request({
    url: '/promo/clear/sku/shopClearRationLog',
    method: 'post',
    data
  })
}

//=====================线上线下商品公共接口===========start=================//

// 下架
export function lowerShelfProduct(data) {
  return request({
    url: '/product/remove/list',
    method: 'post',
    data
  })
}

// 上架
export function upperShelfProduct(data) {
  return request({
    url: '/product/putaway/prod/list',
    method: 'post',
    data
  })
}

// 预览
export function previewProduct(data) {
  return request({
    url: '/product/detail/review',
    method: 'post',
    data
  })
}

// =====================定金商品==============
// 创建
export function addDeposit(data) {
  return request({
    url: '/deposit/add',
    method: 'post',
    data
  })
}
// 列表
export function depositList(data) {
  return request({
    url: '/deposit/list',
    method: 'post',
    data
  })
}
// 详情
export function depositDetail(data) {
  return request({
    url: '/deposit/detail',
    method: 'post',
    data
  })
}
// 更新
export function depositUpdate(data) {
  return request({
    url: '/deposit/update',
    method: 'post',
    data
  })
}

export function depositPrice(data) {
  return request({
    url: '/deposit/price',
    method: 'post',
    data
  })
}

export function depositSettle(data) {
  return request({
    url: '/deposit/settle',
    method: 'post',
    data
  })
}
// 预售下架
export function productRemove(data) {
  return request({
    url: '/product/remove',
    method: 'post',
    data
  })
}
// 库存变动流水list
export function getStockFlowList(data) {
  return request({
    url: '/product/stock/flowList',
    method: 'post',
    data
  })
}
// 查看B2B库存及仓配库存
export function stockMergeView(data) {
  return request({
    url: '/productJoinWms/stockMergeView',
    method: 'post',
    data
  })
}
// 查询wms商品信息
export function getWmsProduct(data) {
  return request({
    url: '/productJoinWms/getWmsProduct',
    method: 'post',
    data
  })
}
// 根据skuId查询已绑wms商品信息
export function bindInfo(data) {
  return request({
    url: '/productJoinWms/getBindInfo',
    method: 'post',
    data
  })
}
// b2b商品绑定wms商品信息
export function buildWms(data) {
  return request({
    url: '/productJoinWms/buildWms',
    method: 'post',
    data
  })
}
// 解绑b2b商品和wms商品信息
export function doUnbuildWms(data){
  return request({
    url: '/productJoinWms/doUnbuildWms',
    method: 'post',
    data
  })
}
// 费率配置列表
export function productSettleList(data){
  return request({
    url: '/payment/productSettle/list',
    method: 'post',
    data
  })
}
// 保存费率配置
export function productSettleSave(data){
  return request({
    url: '/payment/productSettle/save',
    method: 'post',
    data
  })
}
// 修改费率配置
export function productSettleUpdate(data){
  return request({
    url: '/payment/productSettle/update',
    method: 'post',
    data
  })
}
// 费率配置详情
export function productSettleDetail(data){
  return request({
    url: '/payment/productSettle/detail',
    method: 'post',
    data
  })
}
//作废费率配置
export function productSettleDisable(data){
  return request({
    url: '/payment/productSettle/disable',
    method: 'post',
    data
  })
}
//费率设置下面的商品列表
export function productSettleDetailList(data){
  return request({
    url: '/payment/productSettle/list',
    method: 'post',
    data
  })
}
//费率设置下面的商品增加绑定
export function productSettleAddBindWMS(data){
  return request({
    url: '/payment/productSettle/addBindWMS',
    method: 'post',
    data
  })
}

//查询WMS系统库存批次弹窗数据
export function queryStockDialogList(data){
  return request({
    url: '/wms/stock/queryStockBySku',
    method: 'post',
    data
  })
}

// 新增线上商品重构
export function createOnLineProduct(data){
  return request({
    url: '/product/online/create',
    method: 'post',
    data
  })
}

// 属性类型
export function getAttrType(data){
  return request({
    url: '/product/attrType',
    method: 'post',
    data
  })
}

//效验选中批次是否已被绑定
export function checkSnConflict(data){
  return request({
    url: '/product/checkSnConflict',
    method: 'post',
    data
  })
}


// 商品可售卖区域
export function getProductSaleAreaList(data){
  return request({
    url: '/productSaleArea/list',
    method: 'post',
    data
  })
}

// 获取供应商列表
export function getAllSupplierList(data){
  return request({
    url: '/productWmsSupplier/list',
    method: 'post',
    data
  })
}

//组合商品 - 获取可选择商品
export function getAllList(data){
  return request({
    url: '/product/mix/selectSkuList',
    method: 'post',
    data
  })
}
//组合商品 - 新增
export function addCombinationPro(data){
  return request({
    url: '/product/mix/create',
    method: 'post',
    data
  })
}
//组合商品 - 编辑
export function editCombinationPro(data) {
  return request({
    url: '/product/mix/update',
    method: 'post',
    data
  })
}
//组合商品 - 列表
export function getCombinationList(data){
  return request({
    url: '/product/mix/queryPage',
    method: 'post',
    data
  })
}
//组合商品 - 详情
export function getCombinationDetail(data){
  return request({
    url: '/product/mix/getDetail',
    method: 'post',
    data
  })
}
//组合商品 - 上架
export function doOnlineCombination(data){
  return request({
    url: '/product/mix/doOnline',
    method: 'post',
    data
  })
}
//组合商品 - 下架
export function doOfflineCombination(data){
  return request({
    url: '/product/mix/doOffline',
    method: 'post',
    data
  })
}

//组合商品 - 禁用
export function doDisableCombination(data){
  return request({
    url: '/product/mix/doDisable',
    method: 'post',
    data
  })
}

//组合商品 - 启用
export function doEnableCombination(data){
  return request({
    url: '/product/mix/doEnable',
    method: 'post',
    data
  })
}
// 组合商品 -导出
export function exportCombinationProduct(data) {
  return request({
    url: '/product/mix/doExport',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}
//线上商品审核list
export function getOnlineReviewList(data){
  return request({
    url: '/product/audit/queryPage',
    method: 'post',
    data
  })
}
//线上商品审核  提交审核结果
export function submitOnlineReview(data){
  return request({
    url: '/product/audit/doAudit',
    method: 'post',
    data
  })
}
// 查看商品快照
export function orderProductSnapshot(data){
  return request({
    url: '/productSnapshot/orderProductSnapshot',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/product.js